(() => {
  'use strict';
  document.documentElement.classList.add('js');
  const openers = new WeakMap();
  const focusables = 'a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex="0"]';
  let savedScrollStyles = null;
  let backdropStart = null;
  function lockScroll() {
    if (savedScrollStyles) return;
    const html = document.documentElement;
    const body = document.body;
    savedScrollStyles = { overflow: html.style.overflow, gutter: html.style.getPropertyValue('scrollbar-gutter'), padding: body.style.paddingInlineEnd };
    const gutter = window.innerWidth - html.clientWidth;
    if (gutter > 0) {
      if (CSS.supports('scrollbar-gutter', 'stable')) html.style.setProperty('scrollbar-gutter', 'stable');
      else body.style.paddingInlineEnd = `${(parseFloat(getComputedStyle(body).paddingInlineEnd) || 0) + gutter}px`;
    }
    html.style.overflow = 'hidden';
    html.classList.add('dialog-lock');
  }
  function unlockScroll() {
    if (!savedScrollStyles) return;
    const html = document.documentElement;
    html.style.overflow = savedScrollStyles.overflow;
    if (savedScrollStyles.gutter) html.style.setProperty('scrollbar-gutter', savedScrollStyles.gutter);
    else html.style.removeProperty('scrollbar-gutter');
    document.body.style.paddingInlineEnd = savedScrollStyles.padding;
    html.classList.remove('dialog-lock');
    savedScrollStyles = null;
  }
  function openDialog(dialog, opener) {
    if (!(dialog instanceof HTMLDialogElement)) return;
    let returnTarget = opener || document.activeElement;
    const parentDialog = returnTarget?.closest?.('dialog');
    if (parentDialog && parentDialog !== dialog) returnTarget = openers.get(parentDialog) || document.querySelector('[data-cart-open]');
    openers.set(dialog, returnTarget);
    document.querySelectorAll('dialog[open]').forEach(current => { if (current !== dialog) current.close(); });
    if (!dialog.open) dialog.showModal();
    lockScroll();
    document.querySelectorAll('[data-dialog-open]').forEach(button => {
      if (button.dataset.dialogOpen === dialog.id) button.setAttribute('aria-expanded', 'true');
    });
  }
  document.addEventListener('pointerdown', event => {
    const dialog = event.target instanceof HTMLDialogElement ? event.target : null;
    if (!dialog) { backdropStart = null; return; }
    const rect = dialog.getBoundingClientRect();
    backdropStart = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom ? dialog : null;
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const trigger = target.closest('[data-dialog-open]');
    if (trigger && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      const dialog = document.getElementById(trigger.dataset.dialogOpen);
      if (dialog) { event.preventDefault(); openDialog(dialog, trigger); }
    }
    if (target.closest('[data-dialog-close]')) target.closest('dialog')?.close();
    if (target instanceof HTMLDialogElement) {
      const rect = target.getBoundingClientRect();
      if (backdropStart === target && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) target.close();
    }
    const menuLink = target.closest('#MenuDrawer a[href]');
    if (menuLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) menuLink.closest('dialog')?.close();
    document.querySelectorAll('[data-locale-menu][open]').forEach(menu => { if (!menu.contains(target)) menu.open = false; });
  });
  document.addEventListener('close', event => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement)) return;
    document.querySelectorAll('[data-dialog-open]').forEach(button => {
      if (button.dataset.dialogOpen === dialog.id) button.setAttribute('aria-expanded', 'false');
    });
    if (!document.querySelector('dialog[open]')) {
      unlockScroll();
      const opener = openers.get(dialog);
      const target = opener?.isConnected && opener.getClientRects().length ? opener : document.querySelector('[data-cart-open]');
      target?.focus({ preventScroll: true });
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-locale-menu][open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); event.preventDefault(); });
    const dialog = event.target instanceof Element ? event.target.closest('dialog[open]') : null;
    if (!dialog || event.key !== 'Tab') return;
    const nodes = [...dialog.querySelectorAll(focusables)].filter(node => node.getClientRects().length && !node.closest('[hidden]'));
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-localization-select]')) event.target.form.requestSubmit();
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-search-form]')) {
      const field = event.target.querySelector('[name="q"]');
      if (!field.value.trim()) { event.preventDefault(); field.focus(); return; }
      field.value = field.value.trim();
      event.target.closest('dialog')?.close();
    }
    if (!event.target.matches('.localization,.localization-languages,.localization-country')) return;
    const returnTo = event.target.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = `${location.pathname}${location.search}${location.hash}`;
  });
  let country = null;
  function syncCountry() {
    if (country === null) {
      try { country = localStorage.getItem('wings.country'); } catch { country = 'QA'; }
      if (!['QA', 'BH', 'KW', 'OM', 'SA', 'AE'].includes(country)) country = 'QA';
    }
    document.querySelectorAll('[data-country-preference]').forEach(select => { select.value = country; });
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-country-preference]')) return;
    country = event.target.value;
    try { localStorage.setItem('wings.country', country); } catch { /* Keep the in-memory preference. */ }
    syncCountry();
  });
  window.addEventListener('storage', event => {
    if (event.key !== 'wings.country' && event.key !== null) return;
    country = null;
    syncCountry();
  });
  function initAnnouncements() {
    document.querySelectorAll('[data-announcement]').forEach(bar => {
      if (bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';
      const messages = [...bar.querySelectorAll('[data-announcement-message]')];
      const arrows = [...bar.querySelectorAll('[data-announcement-step]')];
      const pause = bar.querySelector('[data-announcement-pause]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, paused = false, hovered = false, focused = false, timer;
      const update = () => {
        clearTimeout(timer);
        const canRotate = bar.dataset.rotate === 'true' && messages.length > 1 && !motion.matches;
        const rotating = canRotate && !paused && !hovered && !focused;
        bar.classList.toggle('announcement--rotating', canRotate);
        arrows.forEach(button => { button.hidden = messages.length < 2; });
        pause.hidden = !canRotate;
        pause.setAttribute('aria-label', paused ? bar.dataset.playLabel : bar.dataset.pauseLabel);
        pause.querySelector('[data-play-icon]').hidden = !paused;
        pause.querySelector('[data-pause-icon]').hidden = paused;
        bar.querySelector('p').setAttribute('aria-live', rotating ? 'off' : 'polite');
        messages.forEach((message, number) => { message.hidden = index !== number; });
        if (rotating) timer = setTimeout(() => step(1), Math.max(1, Number(bar.dataset.interval) || 4000));
      };
      const step = delta => {
        index = (index + delta + messages.length) % messages.length;
        update();
        if (!motion.matches) messages[index].animate?.([{ opacity: 0 }, { opacity: 1 }], { duration: 300 });
      };
      arrows.forEach(button => button.addEventListener('click', () => step(Number(button.dataset.announcementStep))));
      pause.addEventListener('click', () => { paused = !paused; update(); });
      bar.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; update(); } });
      bar.addEventListener('pointerleave', () => { hovered = false; update(); });
      bar.addEventListener('focusin', () => { focused = true; update(); });
      bar.addEventListener('focusout', event => { if (!bar.contains(event.relatedTarget)) { focused = false; update(); } });
      motion.addEventListener('change', update);
      bar.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => { clearTimeout(timer); motion.removeEventListener('change', update); }, { once: true });
      update();
    });
  }
  function init() {
    document.querySelectorAll('[data-info-content] table').forEach(table => {
      if (table.parentElement.classList.contains('rte-wrap')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'rte-wrap';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', table.caption?.textContent || document.querySelector('h1')?.textContent || '');
      table.before(wrapper);
      wrapper.append(table);
    });
    const header = document.querySelector('[data-site-header]');
    if (header && !header.dataset.initialized) {
      header.dataset.initialized = 'true';
      const sentinel = document.querySelector('[data-header-sentinel]');
      if (sentinel && typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver(([entry]) => header.classList.toggle('is-stuck', !entry.isIntersecting && entry.boundingClientRect.top < 0));
        observer.observe(sentinel);
        header.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      }
      header.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') header.classList.add('is-hovered'); });
      header.addEventListener('pointerleave', () => header.classList.remove('is-hovered'));
    }
    document.querySelectorAll('[data-locale-menu]').forEach(menu => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      menu.addEventListener('focusout', event => { if (!menu.contains(event.relatedTarget)) menu.open = false; });
    });
    document.querySelectorAll('#MenuDrawer a[href]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    initAnnouncements();
    syncCountry();
    document.querySelectorAll('.footer-menu').forEach((menu, index) => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      const heading = menu.querySelector('h2');
      const list = menu.querySelector('ul');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'footer-menu__button';
      button.textContent = heading.textContent;
      list.id = `FooterLinks-${index}`;
      button.setAttribute('aria-controls', list.id);
      const media = window.matchMedia('(min-width: 768px)');
      const update = () => {
        heading.replaceChildren(media.matches ? document.createTextNode(button.textContent) : button);
        list.hidden = !media.matches;
        button.setAttribute('aria-expanded', String(media.matches));
      };
      button.addEventListener('click', () => { list.hidden = !list.hidden; button.setAttribute('aria-expanded', String(!list.hidden)); });
      media.addEventListener('change', update);
      update();
    });
  }
  window.Wings = { openDialog, init };
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', event => {
    const section = event.target;
    if (section instanceof Element && section.querySelector('#MenuDrawer')) openDialog(section.querySelector('#MenuDrawer'));
  });
})();
